import { render, staticRenderFns } from "./article-edit.vue?vue&type=template&id=443838d5&scoped=true&"
import script from "./article-edit.vue?vue&type=script&lang=js&"
export * from "./article-edit.vue?vue&type=script&lang=js&"
import style0 from "./article-edit.vue?vue&type=style&index=0&id=443838d5&lang=less&scoped=true&"
import style1 from "@/assets/less/i-switch.less?vue&type=style&index=1&id=443838d5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443838d5",
  null
  
)

component.options.__file = "article-edit.vue"
export default component.exports